import { Component, OnInit } from '@angular/core';
import { FileService } from 'src/app/___LOGIC/___common/__files/file.service';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.css']
})
export class FileListComponent implements OnInit {

  clientId: string = 'client1';  // This would typically come from your authentication or user context
  folder: string = 'processes';  // Default folder (can be 'profile', 'personal', or 'processes')
  files: any[] = [];

  constructor(private fileService: FileService) { }

  ngOnInit(): void {
    this.loadFiles();
  }

  loadFiles() {
    this.fileService.getFiles(this.clientId, this.folder).subscribe(data => {
      this.files = data;
    });
  }

  downloadFile(fileName: string) {
    /* this.fileService.downloadFile(this.clientId, this.folder, fileName).subscribe(response => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url); // Clean up the URL object after download
    }, error => {
      console.error('Download failed', error);
    }); */
  }

  deleteFile(fileName: string) {
    /*  this.fileService.deleteFile(this.clientId, this.folder, fileName).subscribe(() => {
       this.files = this.files.filter(file => file.name !== fileName);
     }); */
  }

   changeFolder(newFolder: string) {
    this.folder = newFolder;
    this.loadFiles();
  }

}
